import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareBehindSquare6"><Path d="M7.5 7.5V3.5H20.5V16.5H16.5M16.5 7.5V20.5H3.5V7.5H16.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconSquareBehindSquare6;
